import { Badge, DefaultTooltip } from 'twyne-new.ui';

export default function StatusFormatter({ info }) {
  const { status, freeBucket } = info.row.original
  const color = STATUS_COLORS[status] || 'neutral'

  if (status === 'disabled') {
    return <Badge color={color} variant='outline'>
      {status}
    </Badge>
  }

  return <DefaultTooltip content={<>
    <div>This bucket is scrubbing new session because the "Current Balance" is less than the "Balance Threshold".</div>
    <div>{Number(freeBucket || 0).toFixed(2)}%</div>
  </>}>
    <Badge color={color} variant='outline'>
      {status}
    </Badge>
  </DefaultTooltip>
}

const STATUS_COLORS = {
  disabled: 'neutral',
  scrubing: 'danger',
  converting: 'success',
}
